'use client'

import { Button } from '@inflow/ui/components/button'
import { Card } from '@inflow/ui/components/card'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@inflow/ui/components/tooltip'
import { cn } from '@inflow/ui/lib/utils'
import { useAtomValue } from 'jotai'
import { motion } from 'motion/react'
import Link from 'next/link'
import { containerStagger, fadeUp } from '../../base-animations'
import CardMeta from '../../components/CardMeta'
import { NavLink } from '../../components/NavLink'
import { latestMediaAppearances } from '../../state/latesMediaAppearancesAtom'
import SectionWrapper from '../Section'

const MotionCard = motion(Card)
const MotionNavLink = motion(NavLink)

export default function MediaAppearances() {
  const { data } = useAtomValue(latestMediaAppearances)

  if (!data?.length) return null

  return (
    <SectionWrapper
      title="Interviews and podcasts"
      action={
        <MotionNavLink href="/media">
          <Button>All appearances</Button>
        </MotionNavLink>
      }
    >
      <motion.div
        className="grid grid-cols-1 gap-3 md:gap-6 lg:grid-cols-[1fr_1fr]"
        variants={containerStagger(0.3)}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.1,
          margin: '-10% 0px -10% 0px',
        }}
      >
        {data.map((media, index) => {

          const badges = [
            {
              title: media.type,
            }
          ]

          if (index === 0) {
            badges.push({
              title: 'Latest' as any,
            })
          }

          return (
            <Link
              className={cn(index === 0 && 'row-[1/3]')}
              key={media.title}
              href={media.url ?? ''}
              target="_blank"
              rel="noreferrer"
            >
              <MotionCard
                className={cn(
                  "relative grid h-full content-between gap-3 border-2 border-transparent px-6 transition-border duration-300 hover:border-primary",
                  // index === 0 && 'border-none'
                )}
                style={{
                  backgroundSize: '150%',
                  // backgroundImage: index === 0 ? "url('/images/bge.webp')" : '',
                }}
                variants={fadeUp()}
              >
                <TooltipProvider>
                  <Tooltip delayDuration={500}>
                    <TooltipTrigger asChild>
                      <h4
                        className={cn(
                          index === 0 ? 'text-lg lg:text-2xl' : 'truncate text-md lg:text-lg',
                        )}
                      >
                        {media.title}
                      </h4>
                    </TooltipTrigger>
                    <TooltipContent align="start">
                      <p>{media.title}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                <CardMeta
                  badges={badges}
                  time={media.createdAt}
                />
              </MotionCard>
            </Link>
          )
        })}
      </motion.div>
    </SectionWrapper>
  )
}
